import { render, staticRenderFns } from "./DispensingComponent.vue?vue&type=template&id=dbc1e64c"
import script from "./DispensingComponent.vue?vue&type=script&lang=js"
export * from "./DispensingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports